var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVehicle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.9,
    height: 48.655,
    viewBox: "0 0 66.9 48.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_17",
    "data-name": "Pfad 17",
    d: "M176.777,19.664h-9.123V7.5H125.082A6.1,6.1,0,0,0,119,13.582v33.45h6.082a9.123,9.123,0,0,0,18.246,0h18.246a9.123,9.123,0,0,0,18.246,0H185.9v-15.2ZM134.2,51.593a4.561,4.561,0,1,1,4.561-4.561A4.555,4.555,0,0,1,134.2,51.593Zm41.052-27.368,5.96,7.6H167.655v-7.6ZM170.7,51.593a4.561,4.561,0,1,1,4.561-4.561A4.555,4.555,0,0,1,170.7,51.593Z",
    transform: "translate(-119 -7.5)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVehicle);
export default __webpack_public_path__ + "static/media/icon-vehicle.6ee16db7e686caece39bd95b76cfcb80.svg";
export { ForwardRef as ReactComponent };